
import React from "react";
import "./profileAdminSkeleton.css";

const ProfileAdminSkeleton = () => {
	return (
		<div className="sf-card sf-profile-skel">
			{/* Carousel / Banner */}
			<div className="sf-skel-block sf-skel-banner shimmer"></div>

			{/* Name + Edit Btn */}
			<div className="sf-skel-row between">
				<div className="sf-skel-line w-60 shimmer"></div>
				<div className="sf-skel-circle shimmer"></div>
			</div>

			{/* Location */}
			<div className="sf-skel-line w-40 shimmer"></div>

			{/* Review summary (rating + count) */}
			<div className="sf-skel-line w-30 shimmer"></div>

			{/* Tabs */}
			<div className="sf-skel-tabs">
				<div className="sf-skel-tab shimmer"></div>
				<div className="sf-skel-tab shimmer"></div>
				<div className="sf-skel-tab shimmer"></div>
			</div>

			{/* Services List */}
			<div className="sf-skel-section-title shimmer"></div>

			<div className="sf-skel-service-list">
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className="sf-skel-service-item shimmer"></div>
				))}
			</div>

			{/* Review summary box */}
			<div className="sf-skel-rsum shimmer"></div>

			{/* Review items */}
			<div className="sf-skel-rev-list">
				{Array.from({ length: 2 }).map((_, i) => (
					<div key={i} className="sf-skel-review-item shimmer"></div>
				))}
			</div>

			{/* Sidebar */}
			<div className="sf-skel-sidebar">
				<div className="sf-skel-side-block shimmer"></div>
				<div className="sf-skel-side-block shimmer"></div>
				<div className="sf-skel-side-block shimmer"></div>
			</div>
		</div>
	);
};

export default ProfileAdminSkeleton;
